var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityCompleted28(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.957.337a2 2 0 012.087 0l2.94 1.799a2 2 0 00.735.27l3.403.532a2 2 0 011.586 1.337l1.117 3.313c.083.246.213.474.383.67l2.287 2.64a2 2 0 01.355 2.026l-1.257 3.277c-.093.241-.138.499-.133.758l.073 3.51a2 2 0 01-1.028 1.79l-3.03 1.683a2 2 0 00-.594.503L19.72 27.16a2 2 0 01-1.957.715l-3.37-.673a1.999 1.999 0 00-.785 0l-3.37.673a2 2 0 01-1.957-.715L6.12 24.445a2 2 0 00-.594-.503l-3.03-1.683a2 2 0 01-1.028-1.79l.072-3.51a2 2 0 00-.132-.758L.15 12.924a2 2 0 01.356-2.026l2.287-2.64a2 2 0 00.383-.67l1.116-3.313A2 2 0 015.88 2.938l3.403-.532a2 2 0 00.734-.27l2.94-1.8z",
    fill: "#4E4E4E",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.398 9.996a1 1 0 01.024 1.414l-7.028 7.27a1 1 0 01-1.438 0l-2.98-3.082-4.83 4.995a1 1 0 11-1.437-1.39l5.548-5.74a1 1 0 011.438 0l2.98 3.083 6.31-6.526a1 1 0 011.413-.024z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.264 10.715a1 1 0 011-1h4.438a1 1 0 011 1v4.592a1 1 0 11-2 0v-3.592h-3.438a1 1 0 01-1-1z",
    fill: "#fff"
  })));
}
export default SvgActivityCompleted28;